var React = require('react');

function AsanaFireBreath (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","d":"M24.063,31C23.188,31,16,31,16,31s-3-0.802-3-4.011\n\tC13,24.241,13,13,13,13s2.617,0,3.667,0c1.741,0,2.973,0.701,3.961,2.401c2.091,3.594,7.843,13.482,7.843,13.482 M17.679,18.208\n\tl3.78,6.497c0,0,5.025,2.474,5.613,2.796C28.273,28.161,29,29.426,29,31c0,1.978-1.307,4-4,4c-2.556,0-11.063,0-11.063,0L16,31\n\t M21,12c0,0,0-4.791,0-7s-1.791-4-4-4s-4,1.791-4,4s0,11,0,11"}));
}

AsanaFireBreath.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"38px","height":"38px","viewBox":"0 0 38 38","enableBackground":"new 0 0 38 38","xmlSpace":"preserve"};

module.exports = AsanaFireBreath;

AsanaFireBreath.default = AsanaFireBreath;
